<div class="field-container">
    <div
        [matMenuTriggerFor]="menu"
        [class.active]="control.value || field.sortState || control.value === false"
        class="field-name"
    >
        <div class="placeholder" [class.active]="control.value || control.value === false">{{ field.placeholder }}</div>
        @if (control.value || control.value === false) {
            <div class="value-text">
                {{ valueText() }}
            </div>
        }
        @if (control.value || control.value === false) {
            <mat-icon class="clear-icon" (click)="$event.stopPropagation(); clear()">clear</mat-icon>
        }
    </div>

    <mat-menu class="filter-menu" #menu="matMenu">
        <div class="field-content" (click)="$event.stopPropagation()">
            <div class="heading">{{ field.placeholder }}</div>

            <div class="icons" fxLayout="row" fxLayoutAlign="space-between center">
                <div>
                    @if (field.sortKey) {
                        <span [class.active]="field.sortState">
                            <mat-icon
                                (click)="sortChange.emit()"
                                class="sort-icon"
                                [class.active]="field.sortState"
                                [class.rotate]="field.sortState === 'desc'"
                            >
                                north
                            </mat-icon>
                        </span>
                    }
                </div>
                <mat-icon (click)="clear()">highlight_off</mat-icon>
            </div>

            <mat-radio-group class="radio-blocks" [formControl]="control">
                @for (item of field.selectValues; track $index) {
                    <mat-radio-button [value]="item.value">{{ item.name }}</mat-radio-button>
                }
            </mat-radio-group>
        </div>
    </mat-menu>
</div>
